import Contexts from "../src/contexts";
import "../src/assets/styles/index.scss";
import authService from "../src/services/authServices";
import { useEffect } from "react";

// eslint-disable-next-line react-hooks/exhaustive-deps
function MyApp({ Component, pageProps }) {
	useEffect(() => {
		authService.login({
			email: process.env.NEXT_PUBLIC_SUPABASE_EMAIL!,
			password: process.env.NEXT_PUBLIC_SUPABASE_PASSWORD!,
		});
	}, []);

	return (
		<Contexts>
			<Component {...pageProps} />

			{/* <ToastContainer /> */}

			<div id="modal"></div>
		</Contexts>
	);
}

export default MyApp;
